import React from 'react'
import styles from "./css/CartNavar.module.css"
import Navbar from '../Navbar/Navbar'

export default function CartNavbar() {
  return (
    <div className={styles.productnavbar}>
        <Navbar/>
    </div>
  )
}
